var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pop-600 text-small wrap-50px bl-color noselect pointer",
    style: _vm.styleCustom,
    on: {
      "click": _vm.openFixationPopUp
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }